export const useCarouselContentData = () => {

  const config = useRuntimeConfig()

  const transform = (response) => {
    const { sanitize } = useUtils();
    

    return {
      carouselContent: sanitize(response.data.attributes.carouselContent),
    }
  }    
  const getCarouselContent = async (deep = true) => {        
    const url = `/api/carousel-content`;

    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
  }
    
  return {
    getCarouselContent,
  }
}